import Button from '@material-ui/core/Button';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handleChangeEvent, handlePost } from '../../../../../utils/AxiosUtil';
import * as util from '../../../../../utils/Util';
import ErrorAwareAmountField from '../../../../common/inputfields/ErrorAwareAmountField';
import ErrorAwareTextField from '../../../../common/inputfields/ErrorAwareTextField';
import { getFromLocalStorage } from "../../../../../utils/Util";
import ErrorAwareTimePicker from '../../../../common/inputfields/ErrorAwareTimePicker';

class NewOccasionalSalaryForDates extends Component {

    state = {
        amount: '',
        names: '',
        startDate: '',
        endDate: '',
        startTime: "08:00",
        endTime: "16:00",
        errors: new Map(),
    }

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();

        const path = '/api/occasionalsalaries';
        const requestObject = {
            "amount": util.toNumber(this.state.amount),
            "names": this.getNames(this.state.names),
            "startDate": this.state.startDate,
            "endDate": this.state.endDate,
            "startTime": this.state.startTime,
            "endTime": this.state.endTime
        };
        handlePost(path, requestObject, this);
        // console.log(requestObject);
    };

    getNames(names) {
        let nameArray = names.split(',');
        let result = nameArray.map(str => str.trim());
        console.log(result);
        return result;
    }

    componentDidMount() {
        this.setAmount();
        this.setState({ startDate: this.props.start, endDate: this.props.end })
    };

    setAmount() {
        console.log(this.props);
        const cookies = getFromLocalStorage("Alkalmi Fizetések", 'settings');
        console.log(cookies);
        let value = ''
        if (cookies) {
            cookies.forEach(function (obj) {
                if (obj.name === 'occasionalSalaryAmount') {
                    value = obj.value;
                }
            })
            this.setState({ amount: value })
        }
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className='flex-form'>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            required
                            name="names"
                            label="Név"
                            autoComplete="on"
                            errors={this.state.errors}
                            value={this.state.names}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareAmountField
                            required
                            name="amount"
                            label="Összeg"
                            errors={this.state.errors}
                            value={this.state.amount}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTimePicker
                            required
                            name="startTime"
                            label="Kezdő időpont"
                            errors={this.state.errors}
                            value={this.state.startTime}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTimePicker
                            required
                            name="endTime"
                            label="Befejezés időpont"
                            errors={this.state.errors}
                            value={this.state.endTime}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            required
                            name="startDate"
                            label="Kezdés"
                            variant="outlined"
                            value={this.state.startDate}
                            errors={this.state.errors}
                            disabled />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            required
                            name="endDate"
                            label="Befejezés"
                            variant="outlined"
                            value={this.state.endDate}
                            errors={this.state.errors}
                            disabled />
                    </div>
                </div>
                <div className="form-actions">
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Hozzáadás
                    </Button>
                </div>
            </form>
        )
    }
}

export default withSnackbar(NewOccasionalSalaryForDates);
